import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-[#1E2A24] text-white">
      <div className="max-w-[1400px] mx-auto px-8 md:px-16 lg:px-24 py-20 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-block">
              <img loading="lazy" 
                src="/images/dilling_el_logo.svg" 
                alt="Dilling El" 
                className="h-8 w-auto brightness-0 invert opacity-90"
              />
            </Link>
            <p className="text-white/40 text-sm mt-6 leading-relaxed max-w-xs">
              Autoriseret el-installatør fra Roskilde. Specialister i energioptimering, intelligent belysning og dokumenterbare energibesparelser i erhvervsbygninger.
            </p>
            {/* LinkedIn */}
            <a 
              href="https://www.linkedin.com/company/dilling-el" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-white/40 hover:text-white transition-colors"
              data-testid="footer-linkedin"
            >
              <Linkedin size={18} />
              <span className="text-sm">LinkedIn</span>
            </a>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <h4 className="text-[11px] tracking-[0.15em] uppercase text-white/40 mb-6">
              Navigation
            </h4>
            <ul className="space-y-3">
              {/* Cases skjult indtil kunden har flere cases
              {[
                { href: '/cases', label: 'Cases' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/60 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              */}
              {[
                { href: '/om-os', label: 'Om os' },
                { href: '/esg', label: 'ESG' },
                { href: '/kontakt', label: 'Kontakt' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-white/60 hover:text-white transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="text-[11px] tracking-[0.15em] uppercase text-white/40 mb-6">
              Ydelser
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/ydelser/energioptimering" className="text-sm text-white/60 hover:text-white transition-colors">
                  Energioptimering
                </Link>
              </li>
              <li>
                <Link to="/ydelser/lysstyring" className="text-sm text-white/60 hover:text-white transition-colors">
                  Intelligent lysstyring
                </Link>
              </li>
              <li>
                <Link to="/ydelser/service" className="text-sm text-white/60 hover:text-white transition-colors">
                  Service & vedligehold
                </Link>
              </li>
              <li>
                <Link to="/nybyg-og-renovering" className="text-sm text-white/60 hover:text-white transition-colors">
                  Nybyg & renovering
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-[11px] tracking-[0.15em] uppercase text-white/40 mb-6">
              Kontakt
            </h4>
            <div className="space-y-3 text-sm">
              <p>
                <a href="mailto:info@dilling-el.dk" className="text-white/60 hover:text-white transition-colors">
                  info@dilling-el.dk
                </a>
              </p>
              <p>
                <a href="tel:+4546461234" className="text-white/60 hover:text-white transition-colors">
                  +45 46 46 12 34
                </a>
              </p>
              <p className="text-white/40 pt-4">
                Gammel Darupvej 5D<br />
                4000 Roskilde
              </p>
              <p className="text-white/30 text-xs pt-2">
                CVR: 39987465
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-white/30 text-xs">
            © {currentYear} Dilling El ApS
          </p>
          <div className="flex gap-8">
            <button 
              onClick={() => window.dispatchEvent(new CustomEvent('openCookieSettings'))}
              className="text-white/30 hover:text-white/60 text-xs transition-colors"
              data-testid="footer-cookie-settings"
            >
              Cookie indstillinger
            </button>
            <Link to="/privatlivspolitik" className="text-white/30 hover:text-white/60 text-xs transition-colors">
              Privatlivspolitik
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
